/**
 * メールプレビューコンポーネント
 *
 * メール設定のプレビュー表示（送信先、件名、添付ファイル）
 */

import { Stack, Text, Group, Alert, Box } from "@mantine/core";
import { AlertCircle } from "lucide-react";
import { PlaygroundResult } from "../../services/playgroundService";

interface TimelineEmailPreviewProps {
  emailPreview: NonNullable<PlaygroundResult["emailPreview"]>;
}

export function TimelineEmailPreview({
  emailPreview,
}: TimelineEmailPreviewProps) {
  return (
    <Box
      mt="xs"
      p="sm"
      style={{
        backgroundColor: "var(--mantine-color-default)",
        borderRadius: "6px",
        border: "1px solid var(--mantine-color-default-border)",
      }}
    >
      <Alert
        color="blue"
        variant="light"
        icon={<AlertCircle size={14} />}
        p="xs"
        mb="xs"
      >
        <Text size="xs">
          プレビューです。実際にはメールは送信されません。
        </Text>
      </Alert>
      <Stack gap={4}>
        <Group gap="xs">
          <Text size="xs" fw={500} w={80}>
            送信先:
          </Text>
          <Text size="xs">{emailPreview.to.join(", ")}</Text>
        </Group>
        <Group gap="xs">
          <Text size="xs" fw={500} w={80}>
            件名:
          </Text>
          <Text size="xs">{emailPreview.subject}</Text>
        </Group>
        <Group gap="xs">
          <Text size="xs" fw={500} w={80}>
            添付:
          </Text>
          <Text size="xs">{emailPreview.attachmentName}</Text>
        </Group>
      </Stack>
    </Box>
  );
}
